import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const AccreditationSection = () => {
  const accreditations = [
    {
      name: "Office of the Data Protection Commissioner (ODPC)",
      logo: "assets/ODPC.png",
      description: "Karumo TTI is registered and compliant with data protection and privacy standards set by the Office of the Data Protection Commissioner (ODPC)",
      status: "Active",
    },
    {
      name: "Technical Vocational Education and Training Authority (TVETA)",
      logo: "assets/TVETA.png",
      description: "Karumo TTI is registed and compliant with accreditation standards for technical and vocational education institutions set by the Technical Vocational Education and Training Authority (TVETA)",
      status: "Active",
    },
    {
      name: "ISO 27001:2013 Information Security Management System (ISMS)",
      logo: "assets/isms.jpg",
      description: "Karumo TTI is ISO 27001:2013 For Information Security Management System",
      status: "Active",
    },
    {
      name: "KASNEB",
      logo: "assets/kasneb.svg",
      description: "Karumo TTI is recognized and a registered center with KASNEB",
      status: "Active",
    }
  ];

  return (
    <section className="py-20 bg-background bg-gradient-to-br from-blue-700 to-yellow-500">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Accreditations & Certifications</h2>
          <p className="text-xl text-white max-w-3xl mx-auto">
            Our commitment to quality education is validated by prestigious accreditations and industry recognition
          </p>
        </div>

        {/* Main Accreditations */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {accreditations?.map((accreditation, index) => (
            <div key={index} className="bg-card rounded-2xl p-6 shadow-card-lg border border-border hover:shadow-xl transition-shadow duration-300">
              <div className="text-center mb-4">
                <div className="w-20 h-20 mx-auto mb-4 rounded-xl overflow-hidden bg-muted/50 flex items-center justify-center">
                  <Image
                    src={accreditation?.logo}
                    alt={accreditation?.name}
                    className="w-20 h-20 object-contain"
                  />
                </div>
                <h3 className="text-lg font-bold text-foreground mb-2">{accreditation?.name}</h3>
              </div>

              <div className="space-y-3">
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {accreditation?.description}
                </p>

                <div className="bg-muted/50 rounded-lg p-3 space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-xs text-muted-foreground">Status</span>
                    <span className={`text-xs font-medium px-2 py-1 rounded-full ${
                      accreditation?.status === 'Active' || accreditation?.status === 'Certified' || accreditation?.status === 'Grade A'
                        ? 'bg-success/10 text-success' :'bg-warning/10 text-warning'
                    }`}>
                      {accreditation?.status}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Service Charter */}
        <div className="mt-16 bg-muted rounded-2xl p-8 border border-border">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-black mb-2">Our Service Charter</h3>
            <p className="text-muted-foreground text-xl">Transparent commitments to our students and stakeholders</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-card/80 backdrop-blur-sm rounded-xl p-6 border border-border">
              <Icon name="Clock" size={24} className="text-primary mb-3" />
              <h4 className="font-semibold text-foreground mb-2">Response Time</h4>
              <p className="text-sm text-muted-foreground">Student queries resolved within 24 hours</p>
            </div>

            <div className="bg-card/80 backdrop-blur-sm rounded-xl p-6 border border-border">
              <Icon name="Shield" size={24} className="text-success mb-3" />
              <h4 className="font-semibold text-foreground mb-2">Quality Assurance</h4>
              <p className="text-sm text-muted-foreground">Continuous monitoring of educational standards</p>
            </div>

            <div className="bg-card/80 backdrop-blur-sm rounded-xl p-6 border border-border">
              <Icon name="Users" size={24} className="text-accent mb-3" />
              <h4 className="font-semibold text-foreground mb-2">Student Support</h4>
              <p className="text-sm text-muted-foreground">Dedicated counseling and career guidance</p>
            </div>

            <div className="bg-card/80 backdrop-blur-sm rounded-xl p-6 border border-border">
              <Icon name="FileText" size={24} className="text-warning mb-3" />
              <h4 className="font-semibold text-foreground mb-2">Transparency</h4>
              <p className="text-sm text-muted-foreground">Open access to policies and procedures</p>
            </div>

            <div className="bg-card/80 backdrop-blur-sm rounded-xl p-6 border border-border">
              <Icon name="TrendingUp" size={24} className="text-primary mb-3" />
              <h4 className="font-semibold text-foreground mb-2">Continuous Improvement</h4>
              <p className="text-sm text-muted-foreground">Regular feedback integration and upgrades</p>
            </div>

            <div className="bg-card/80 backdrop-blur-sm rounded-xl p-6 border border-border">
              <Icon name="Handshake" size={24} className="text-success mb-3" />
              <h4 className="font-semibold text-foreground mb-2">Industry Connect</h4>
              <p className="text-sm text-muted-foreground">Strong partnerships for placement opportunities</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccreditationSection;